import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AppConsts } from '@shared/commonHelper/AppConsts';

/**
 * Holds whether the workspace Calendar feature is currently on for this tenant (E2 master switch,
 * member-safe = server kill-switch && tenant policy). Seeded at bootstrap from `getMySettings()` and
 * refreshed live when a `tenant.calendar.featureToggled` SignalR event arrives, so the Calendar nav
 * item (and page) appear/disappear in real time on every user's open tab — no refresh.
 *
 * Read through the `enabled` getter (used by `AppComponentBase.showCalendarNav`, re-evaluated each
 * change-detection cycle). Always false when the FE kill-switch (`AppConsts.calendarV1FeatureEnabled`)
 * is off.
 */
@Injectable({ providedIn: 'root' })
export class CalendarFeatureService {
    private _enabled = false;

    /** Emits the new enabled state whenever it changes (so consumers can redirect/refresh imperatively). */
    readonly changed$ = new Subject<boolean>();

    get enabled(): boolean {
        return AppConsts.calendarV1FeatureEnabled && this._enabled;
    }

    update(enabled: boolean): void {
        const next = !!enabled;
        if (next === this._enabled) {
            return;
        }
        this._enabled = next;
        this.changed$.next(this.enabled);
    }
}
